import type { ReactNode } from 'react';

/** Die weiche weisse Karte ohne Rand - das tragende Element der Oberflaeche
 *  (Design A: "Klar & ruhig"). Traegt sich allein durch den Kontrast zur
 *  grauen Seitenflaeche, kein Rand, kein Schatten. */
export function Karte({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={`rounded-2xl bg-white ${className}`}>{children}</div>;
}
